import { z } from 'zod';
import zxcvbn from 'zxcvbn';

/*
 * One set of password rules for every place a password is chosen: signup,
 * the code step after a refresh, an invitation, and a reset. Shown as a
 * checklist (components/NewPassword) and enforced here; Keycloak's own policy
 * still has the last word, and its refusal comes back as INVALID_ARGUMENT.
 */
export const PASSWORD_MIN = 8;

const longEnough = (p: string) => p.length >= PASSWORD_MIN;
const hardToGuess = (p: string) => p.length > 0 && zxcvbn(p).score >= 3;

/** The rules, for the checklist. */
export const passwordChecks = (p: string) => [
    { label: `At least ${PASSWORD_MIN} characters`, met: longEnough(p) },
    { label: 'Hard to guess: not a common word or pattern', met: hardToGuess(p) },
];

export const passwordRule = z
    .string()
    .refine(longEnough, `Use at least ${PASSWORD_MIN} characters.`)
    .refine(hardToGuess, 'That one is easy to guess. Add another word, or mix in numbers and symbols.');

/** `shape` plus a new password. Typed once, with an eye to check it. */
export function withNewPassword<T extends z.ZodRawShape>(shape: T) {
    return z.object({ ...shape, password: passwordRule });
}
